export default __webpack_public_path__ + "static/media/tool-field-outdoor-half.56e6accd.svg";